import { render, staticRenderFns } from "./JumlahPenerimaPenghargaanProvinsi.vue?vue&type=template&id=1c33f8bc&"
import script from "./JumlahPenerimaPenghargaanProvinsi.vue?vue&type=script&lang=js&"
export * from "./JumlahPenerimaPenghargaanProvinsi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports